// src/utils/groupByCategory.js

// This function groups menu items by their "category" field
export const groupByCategory = (menuItems) => {
    const grouped = {};
  
    menuItems.forEach(item => {
      const category = item.category || "Others"; // Default to "Others" if no category
      if (!grouped[category]) {
        grouped[category] = [];
      }
      grouped[category].push(item);
    });
  
    return grouped;
  };
  